import { useState as n, useEffect as o } from "react";
const s = () => {
  const [, r] = n({});
  o(() => {
    let e = 0;
    const t = () => {
      e = window.setTimeout(() => {
        r({});
      }, 150);
    };
    return window.addEventListener("resize", t), () => {
      clearTimeout(e), window.removeEventListener("resize", t);
    };
  }, []);
};
export {
  s as useRerenderOnWindowResize
};
